<template>
  <div class="eva">
    <Nav/>


    <div class="goodsBox" v-if="goods.id">
      <Goods :is_order="is_order" :goods="goods" />
    </div>
    <div class="EvaOptions">
      <span class="item" :class="evaluate == 1 && 'on'" @click="evaluate = 1">好评</span>
      <span class="item" :class="evaluate == 0 && 'on'" @click="evaluate = 0">中评</span>
      <span class="item" :class="evaluate == -1 && 'on'" @click="evaluate = -1">差评</span>
    </div>
    <div class="evatext">
      <textarea cols="30" rows="4" placeholder="请对商品做出评价" v-model="content"></textarea>
    </div>

    <div class="imgBox">
      <div class="item" v-for="item in imgList" :key="item.id">
        <img src="../../assets/my/hide.png" alt class="delete" @click="delimg(item.id)" />
        <img :src="item.url" class="goods" />
      </div>

      <div class="upload" @click="openCamera" v-if="imgList.length<4">
        <img src="../../assets/my/addEva.png" />
      </div>
    </div>
    <div class="btnbox">
      <input type="button" value="发表评价" @click="submit" />
    </div>
  </div>
</template>

<style lang="less" scoped>
.eva {
  background-color: #fff;
  .goodsBox {
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
  }
  .EvaOptions {
    width: 100%;
    height: 105px;
    padding: 0 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .item {
      width: 100px;
      height: 55px;
      line-height: 55px;
      text-align: center;
      font-size: 24px;
      color: #666;
      border: 1Px solid #ddd;
      margin-right: 35px;
    }
    .on {
      color: #fff;
      background-color: #e42129;
      border: none;
    }
  }
  .evatext {
    width: 100%;
    height: 198px;
    background: #fff;
    box-sizing: border-box;
    padding: 0 24px;
    textarea {
      width: 100%;
      height: 100%;
      font-size: 24px;
      border: none;
    }
  }
  .imgBox {
    width: 100%;
    // height: 215px;
    margin-top: 20px;
    box-sizing: border-box;
    padding: 0 24px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .item {
      width: 215px;
      height: 215px;
      // overflow: hidden;
      margin-right: 10px;
      position: relative;
      margin-bottom: 10px;
      .goods {
        width: 100%;
        height: 100%;
      }
      .delete {
        position: absolute;
        top: -20px;
        right: -20px;
        width: 40px;
        height: 40px;
      }
    }
    .upload {
      width: 215px;
      height: 215px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1Px solid #ddd;
      img {
        width: 76px;
        height: 76px;
      }
    }
  }
  .btnbox {
    width: 100%;
    height: 100px;
    box-sizing: border-box;
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 21px;
    input {
      border: none;
      width: 144px;
      height: 45px;
      border-radius: 8px;
      text-align: center;
      line-height: 45px;
      color: #fff;
      background-color: #e42129;
      font-size: 24px;
      -webkit-appearance: none;
    }
  }
}
</style>

<script>
import Goods from "../../component/goods/GoodsOrder";
export default {
  components: {
    Goods
  },
  data() {
    return {
      is_order: false,
      goods: {},
      evaluate: 1,
      content: "",
      imgList: []
    };
  },
  computed: {
    pic_ids() {
      return this.imgList.map(item => item.id).join(",");
    }
  },
  created() {
    if (!this.$store.state.isIos) {
      let url = location.href.split("#")[0];
      this.$http({
        url: `jsApi`,
        data: {
          url
        }
      }).then(res => {
        this.$wx.config({
          debug: false,
          appId: res.jsdata.appId,
          timestamp: res.jsdata.timestamp,
          nonceStr: res.jsdata.nonceStr,
          signature: res.jsdata.signature,
          jsApiList: ["chooseImage", "uploadImage","getLocalImgData"]
        });
      });
    }

    let id = this.$route.query.id;
    this.getEavPage(id);
  },

  methods: {
    getEavPage(id) {
      this.$http({
        url: "evaluatePage",
        data: {
          id
        }
      }).then(res => (this.goods = res));
    },

    openCamera() {
      this.$wx.chooseImage({
        count: 1,
        sizeType: ["original", "compressed"],
        sourceType: ["album", "camera"],
        success: res => {
          let localId = res.localIds[0];
          this.$wx.uploadImage({
            localId,
            success: res => {
              this.$http({
                url: "gzhUpPic",
                data: {
                  medias: res.serverId
                }
              }).then(img => {
                this.$toast('图片上传成功')
                if(this.$store.state.isIos){
                  // 苹果手机
                   this.$wx.getLocalImgData({
                    localId,
                    success:local=>{
                      this.imgList.push({ id: img[0].id, url: local.localData });
                    }
                  })
                }else{
                    this.imgList.push({ id: img[0].id, url: localId });
                }
              }).chtch(err=>{
                this.content = err
              })
            }
          });
        }
      });
    },
    delimg(id) {
      this.imgList = this.imgList.filter(item => item.id != id);
    },
    submit() {
      let id = this.goods.id;
      let content = this.content;
      let reg = /\S/;
      if (!reg.test(content)) content = "用户未发表评论内容";


      let evaluate = this.evaluate;
      let pic_ids = this.pic_ids;
      let data = {id,content,evaluate}

      if(pic_ids.length) data.pic_ids = pic_ids
      this.$http({
        url: "subEvaluate",
        data
      }).then(res => {
        this.$toast("评论成功");
        setTimeout(() => {
          this.$router.go(-1);
        }, 1500);
      });
    }
  }
};
</script>
